// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__dKieS","productName":"Table_productName__3Vsrf"};